export const parseNumber = (s) =>
	s
		? typeof s === 'string'
			? Number(s.replace(/,/g, '.').replace(/[^0-9.]/g, ''))
			: s
		: 0;


export function replaceCommas(obj) {
	let r = {};
	Object.keys(obj).forEach(key => {
		r[key] = parseNumber(obj[key]);
	});
	return r;
}
